module.exports = __webpack_public_path__ + "static/lastfm-52a5d69a85ac402c7452ae594c462023.png";